import styled from 'styled-components'

const BoardSection = styled.section`
  width: 100%;
  height: 100%;
  width: fit-content;
  height: fit-content;
  white-space: pre;
  user-select: none;
  
  @media screen and (-webkit-min-device-pixel-ratio:0) {
      box-shadow: 0 3px 4px 0 rgba(0,0,0,0.14), 0 3px 3px -2px rgba(0,0,0,0.12), 0 1px 8px 0 rgba(0,0,0,0.20);
}
`

export default BoardSection
